import styled from "styled-components";
import { Input } from "antd";

const { TextArea } = Input;

export const StyledTextArea = styled(TextArea)`
  margin-top: 40px;
  margin-bottom: 40px;
`;
